import { SearchError } from './setSearchModeMutator.locstring.json';
import { Searching, ZeroSearchResults } from '../strings.locstring.json';
import loc from 'owa-localize';

import getStore from '../store';
import { CalendarSearchListViewState } from '../schema/CalendarSearchListViewState';
import { EmptySearchResultsProps } from '../utils/EmptySearchResultsProps';
import { getIsLightBaseTheme } from 'owa-theme';
import { mutator } from 'satcheljs';
import { setSearchMode } from '../actions/searchResultStoreActions';

/**
 * Sets the current state of search.
 */
export let setSearchModeMutator = mutator(setSearchMode, search => {
    let store = getStore();

    let SEARCHING_SVG;
    let EMPTYSEARCH_SVG;
    let LOADINGERROR_SVG;

    if (getIsLightBaseTheme()) {
        SEARCHING_SVG = require('owa-empty-state/lib/svg/colored/searching.svg');
        EMPTYSEARCH_SVG = require('owa-empty-state/lib/svg/colored/emptySearch_calendar.svg');
        LOADINGERROR_SVG = require('owa-empty-state/lib/svg/colored/loadingError.svg');
    } else {
        SEARCHING_SVG = require('owa-empty-state/lib/svg/gray/searching.svg');
        EMPTYSEARCH_SVG = require('owa-empty-state/lib/svg/gray/emptySearch_calendar.svg');
        LOADINGERROR_SVG = require('owa-empty-state/lib/svg/gray/loadingError.svg');
    }

    const emptySearchResultsProps: EmptySearchResultsProps = { icon: '', mainMessage: '' };
    switch (search.mode) {
        case CalendarSearchListViewState.Loading:
            emptySearchResultsProps.icon = SEARCHING_SVG;
            emptySearchResultsProps.mainMessage = loc(Searching);
            break;
        case CalendarSearchListViewState.Empty:
            // 3S returns a "MoreResultsAvailable" boolean flag for every query call.
            // They generally take a best guess on whether or not they have more results. So we do not want to totally rely on that.
            // There is a corner case wherein, they may return a query call with 0 results. The generic logic of 0 results will set the CalendarSearchListViewState to empty.
            // So for this exception case, we need to check if the store searchResults are empty before setting the flag.
            if (store.searchResults.length == 0) {
                emptySearchResultsProps.icon = EMPTYSEARCH_SVG;
                emptySearchResultsProps.mainMessage = loc(ZeroSearchResults);
            } else {
                search.mode = CalendarSearchListViewState.Loaded;
            }
            break;
        case CalendarSearchListViewState.Error:
            emptySearchResultsProps.icon = LOADINGERROR_SVG;
            emptySearchResultsProps.mainMessage = loc(SearchError);
            break;
        default:
            emptySearchResultsProps.icon = '';
            emptySearchResultsProps.mainMessage = '';
            break;
    }

    store.searchMode = search.mode;
    store.emptyListContents = emptySearchResultsProps;
});
